<template>
    <div class="row">
        <div class="panelMap-wrap">
            <div class="panelMap shadow2">

                <div class="panelMap-h">
                    <p v-if="static.address">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" viewBox="0 0 16 21"><path id="Forma_1" data-name="Forma 1" class="fill-pur" d="M1228,676a7.981,7.981,0,0,0-8,7.958c0,4.274,7.38,12.556,7.69,12.9a0.414,0.414,0,0,0,.58 .033,0.159,0.159,0,0,0,.04-0.033c0.31-.352,7.69-8.631,7.69-12.9A7.984,7.984,0,0,0,1228,676Zm0,19.966c-1.41-1.637-7.18-8.511-7.18-12.012a7.18,7.18,0,0,1,14.36,0C1235.18,687.454,1229.41,694.336,1228,695.965Zm0.15-15.975a4.312,4.312,0,1,0,4.34,4.311A4.329,4.329,0,0,0,1228.15,679.99Zm0,7.807a3.493,3.493,0,1,1,3.51-3.492A3.508,3.508,0,0,1,1228.15,687.8Z" transform="translate(-1220 -676)"></path></svg>
                        <span>{{ static.address }}</span>
                    </p>
                    <p v-if="static.phone.length">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" viewBox="0 0 19 19"><path class="fill-pur" d="M1192.5,692.657l-0.74-.492-0.53-.353-2.58-1.72a1.12,1.12,0,0,0-1.5.243l-1.12,1.441a0.473,0.473,0,0,1-.61.13l-0.22-.118a17.991,17.991,0,0,1-5.99-5.993l-0.11-.212a0.475,0.475,0,0,1,.12-0.617l1.44-1.12a1.127,1.127,0,0,0,.25-1.5l-2.57-3.846a1.11,1.11,0,0,0-1.5-.338l-1.61.965a2.27,2.27,0,0,0-1.04,1.343c-0.57,2.11-.14,5.752,5.22,11.117a36.482,36.482,0,0,0,6.05,4.528l0.96,0.394a14.689,14.689,0,0,0,2.62.493,5.677,5.677,0,0,0,1.49-.2,2.288,2.288,0,0,0,1.34-1.034l0.97-1.607A1.113,1.113,0,0,0,1192.5,692.657Zm-0.21,1.179-0.96,1.608a1.625,1.625,0,0,1-.97.75,6.155,6.155,0,0,1-3.77-.293,0.224,0.224,0,0,0-.08-0.032,19.527,19.527,0,0,1-6.65-4.735c-5.15-5.148-5.59-8.551-5.06-10.5a1.678,1.678,0,0,1,.75-0.968l1.61-.965a0.494,0.494,0,0,1,.66.148l1.39,2.091,1.17,1.754a0.488,0.488,0,0,1-.11.652l-1.44,1.121a1.1,1.1,0,0,0-.29,1.422l0.11,0.207a13.532,13.532,0,0,0,2.75,3.5,13.372,13.372,0,0,0,3.5,2.745l0.21,0.115a1.108,1.108,0,0,0,1.42-.294l1.12-1.44a0.485,0.485,0,0,1,.65-0.106l3.85,2.566A0.479,0.479,0,0,1,1192.29,693.836Z" transform="translate(-1174 -678)"/></svg>
                        <a :href="'tel:' + static.phone">{{ static.phoneFormat }}</a>
                    </p>
                </div>
                <div class="panelMap-c">
                    <div>
                        <input id="pmc1" type="radio" name="route_type" v-model="routeMode" @change="changeRouteMode" @click="changeRouteMode" value="masstransit">
                        <label class="label1" for="pmc1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="29" viewBox="0 0 23 29"><path class="fill-black" d="M1275.12,25h-17.25a2.837,2.837,0,0,0-2.87,2.788V47.865a2.613,2.613,0,0,0,1.18,2.091,1.132,1.132,0,0,0-.03.139v1.952A1.969,1.969,0,0,0,1258.16,54h0.58a1.969,1.969,0,0,0,2.01-1.952V50.654h11.5v1.394A1.969,1.969,0,0,0,1274.26,54h0.58a1.969,1.969,0,0,0,2.01-1.952V50.1a2.759,2.759,0,0,0,1.15-2.231V27.788A2.84,2.84,0,0,0,1275.12,25ZM1259.6,52.048a0.832,0.832,0,0,1-.86.837h-0.58a0.832,0.832,0,0,1-.86-0.837V50.514a3.078,3.078,0,0,0,.86.14h1.44v1.394Zm16.1,0a0.832,0.832,0,0,1-.86.837h-0.58a0.832,0.832,0,0,1-.86-0.837V50.654h1.72a3.59,3.59,0,0,0,.58-0.056v1.45Zm1.15-4.183a1.708,1.708,0,0,1-1.73,1.673h-16.96a2,2,0,0,1-2.01-1.673V42.846h20.7v5.019Zm0-6.135h-20.7V30.577h20.7V41.731Zm0-12.269h-20.7V27.788a1.706,1.706,0,0,1,1.72-1.673h17.25a1.708,1.708,0,0,1,1.73,1.673v1.673Zm-11.5-2.231h-3.74a0.558,0.558,0,1,0,0,1.115h3.74A0.558,0.558,0,1,0,1265.35,27.231Zm3.45,0h-0.86a0.558,0.558,0,1,0,0,1.115h0.86A0.558,0.558,0,1,0,1268.8,27.231Zm-9.49,20.356a1.674,1.674,0,1,0-1.72-1.673A1.708,1.708,0,0,0,1259.31,47.586Zm0-2.231a0.558,0.558,0,1,1-.57.558A0.57,0.57,0,0,1,1259.31,45.356Zm14.38,2.231a1.674,1.674,0,1,0-1.73-1.673A1.7,1.7,0,0,0,1273.69,47.586Zm0-2.231a0.558,0.558,0,1,1-.58.558A0.568,0.568,0,0,1,1273.69,45.356Z" transform="translate(-1255 -25)"/></svg>
                            <span>На шаттл-басе</span>
                        </label>
                        <input id="pmc2" type="radio" name="route_type" v-model="routeMode" @change="changeRouteMode" value="auto">
                        <label class="label2" for="pmc2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27"><path class="fill-black" d="M1221,34.729v-0.1l-1.53-6.969A3.365,3.365,0,0,0,1216.2,25h-14.73a3.357,3.357,0,0,0-3.27,2.66l-1.53,7a0.317,0.317,0,0,0,0,.269A3.376,3.376,0,0,0,1195,37.86v6.733a3.188,3.188,0,0,0,1.37,2.525,1.248,1.248,0,0,0-.04.168v2.356A2.336,2.336,0,0,0,1198.67,52h0.66a2.336,2.336,0,0,0,2.34-2.357V47.96h14.66v1.683A2.336,2.336,0,0,0,1218.67,52h0.66a2.336,2.336,0,0,0,2.34-2.357V47.287a3.371,3.371,0,0,0,1.33-2.693V37.827A3.417,3.417,0,0,0,1221,34.729Zm-21.47-6.767a2,2,0,0,1,1.94-1.582h14.73a1.966,1.966,0,0,1,1.93,1.582l1.44,6.5H1198.1Zm0.8,21.647a0.985,0.985,0,0,1-1,1.01h-0.66a0.985,0.985,0,0,1-1-1.01V47.758a3.4,3.4,0,0,0,1,.168h1.66V49.61Zm20,0a0.985,0.985,0,0,1-1,1.01h-0.66a0.985,0.985,0,0,1-1-1.01V47.926h2a4.026,4.026,0,0,0,.66-0.067V49.61Zm1.34-5.05a2.016,2.016,0,0,1-2,2.02h-21a2.356,2.356,0,0,1-2.34-2.02V37.827a2.016,2.016,0,0,1,2-2.02h21.34a2.016,2.016,0,0,1,2,2.02V44.56ZM1200,38.837a2.02,2.02,0,1,0,2,2.02A2.016,2.016,0,0,0,1200,38.837Zm0,2.693a0.673,0.673,0,1,1,.67-0.673A0.673,0.673,0,0,1,1200,41.53Zm18-2.693a2.02,2.02,0,1,0,2,2.02A2.016,2.016,0,0,0,1218,38.837Zm0,2.693a0.673,0.673,0,1,1,.67-0.673A0.673,0.673,0,0,1,1218,41.53Z" transform="translate(-1195 -25)"/></svg>
                            <span>Маршрут<br> для авто</span>
                        </label>

                        <div class="panelRoute" v-if="routeMode === 'auto' || segmentPreloader || inputSearch.length || routeSegments.length">
                            <div class="input-wrap" v-if="routeMode === 'auto'">
                                <input
                                    class="input"
                                    id="suggest"
                                    type="text"
                                    :value.trim="inputSearch"
                                    @input="changeInputSearch($event.target.value)"
                                    placeholder="Откуда Вы поедете?"
                                >
                                <input type="submit" @click="clearInputSearch" class="close">
                            </div>
                            <div v-if="segmentPreloader || inputSearch.length || routeSegments.length" id="map-segments" class="scroll">
                                <div v-if="segmentPreloader" class="preloader">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="lds-message" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;"><g transform="translate(16.666666666666668 50)"><circle cx="0" cy="0" r="5" fill="#ff0071" transform="scale(0.570054 0.570054)"><animateTransform attributeName="transform" type="scale" begin="-0.4s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"/></circle></g><g transform="translate(33.333333333333336 50)"><circle cx="0" cy="0" r="5" fill="#ffd200" transform="scale(0.286592 0.286592)"><animateTransform attributeName="transform" type="scale" begin="-0.3s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"/></circle></g><g transform="translate(50 50)"><circle cx="0" cy="0" r="5" fill="#00b705" transform="scale(0.0653472 0.0653472)"><animateTransform attributeName="transform" type="scale" begin="-0.2s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"/></circle></g><g transform="translate(66.66666666666667 50)"><circle cx="0" cy="0" r="5" fill="#ff9a00" transform="scale(0.00817746 0.00817746)"><animateTransform attributeName="transform" type="scale" begin="-0.1s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"/></circle></g><g transform="translate(83.33333333333333 50)"><circle cx="0" cy="0" r="5" fill="#2d3888" transform="scale(0.170392 0.170392)"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"/></circle></g></svg>
                                </div>
                                <div v-if="inputSearch.length || routeSegments.length">
                                    <div id="ymaps-search-result">
                                        <a v-for="address in addressesFound"
                                           @click="selectAddress(address)"
                                        >{{ address}}</a>
                                        <a v-if="isErrorAddressFound && !segmentPreloader"
                                           class="not-found" href="javascript:void(0)">Не найдено</a>
                                    </div>
                                    <ul v-if="routeSegments.length && selectedAddress.stops == null">
                                        <li v-for="segment in routeSegments">{{ segment }}</li>
                                    </ul>
                                    <div v-else-if="routeSegments.length === 2 && selectedAddress.stops != null">
                                        <div v-if="selectedAddress.stops.from != null">
                                            <h5>{{ routeSegments[0]}}</h5>
                                            <ul>
                                                <li v-for="item in selectedAddress.stops.from">{{ item.stop }}</li>
                                            </ul>
                                        </div>
                                        <div v-if="selectedAddress.stops.to != null">
                                            <h5>{{ routeSegments[1]}}</h5>
                                            <ul>
                                                <li v-for="item in selectedAddress.stops.to">{{ item.stop }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <p v-else-if="isErrorRouteSegment">Не удалось построить маршрут</p>
                                </div>
                            </div>
                            <div v-if="segmentPreloader || inputSearch.length || routeSegments.length" class="btn-wrap back">
                                <button class="btn medium" type="button" @click="changeRouteMode">
                                    <span>Назад к маршрутам</span>
                                </button>
                            </div>
                        </div>
                        <div v-if="!inputSearch.length && !routeSegments.length && !segmentPreloader && masstransit.length" class="itemPm pm1">
                            <div v-for="item in masstransit" class="busLine">
                                <div class="bus-item pur">
                                    <div class="imgBus" :style="'background-color:'+item.color"></div>
                                    <div class="infoBus" @click="selectAddress(item)">
                                        <p class="text">{{ item.text_client }}</p>
                                        <span class="purText">{{ item.text_additional }}</span>
                                    </div>
                                    <a
                                        v-if="item.image"
                                        @click="setImageModal('/storage/app/media/' + item.image)"
                                        target="_blank"
                                        class="detailedBus"
                                    >Расписание</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="map"></div>
        <div v-if="imageModal" class="popup modal animated fadeIn active large">
            <div class="popup-wrap">
                <button class="close" @click="setImageModal('')"></button>
                <h2>Расписание</h2>
                <img :src="imageModal"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MapHowToGoComponent",
        data: function () {
            return {
                ...rioData,
                masstransit: [],
                yandexMap: '',
                suggest: '',
                inputSearch: '',
                isErrorRouteSegment: false,
                isErrorAddressFound: false,
                routeSegments: [],
                addressesFound: [],
                segmentPreloader: false,
                selectedAddress: '',
                routeMode: 'masstransit',
                imageModal: '',
            };
        },
        created() {
            this.masstransit = this.static.masstransit;

            ymaps.ready(function () {
                this.initMaps();
            }.bind(this));
        },
        methods: {
            initMaps: function () {
                this.yandexMap = new ymaps.Map('map', {
                    center: this.static.coordinates,
                    zoom: 16,
                    controls: []
                });

                let isWidthMobile = window.clientWidth < 1025;

                let marginPx = 30;
                let leftPointX = isWidthMobile ? 0 : document.querySelector('.panelMap-wrap').getBoundingClientRect().right + marginPx;
                let rightPointX = isWidthMobile ? 0 : marginPx;

                this.yandexMap.margin.addArea(
                    {top: 0, left: 0, width: leftPointX, height: '100%'},
                    {top: 0, right: rightPointX, width: leftPointX, height: '100%'}
                );

            },
            selectAddress: function (address) {
                $('#suggest').addClass('fill');
                this.selectedAddress = address;

                if (typeof address === "string") {
                    this.inputSearch = address;
                } else {
                    this.inputSearch = '';
                }

                this.createRoute();
            },
            changeInputSearch: function (value) {
                this.inputSearch = value;
                let self = this;

                this.segmentPreloader = true;
                this.addressesFound = [];
                this.routeSegments = [];
                this.isErrorRouteSegment = false;
                this.isErrorAddressFound = false;

                new ymaps.suggest(self.inputSearch, {
                    boundedBy: [
                        [60.165320, 29.299391],
                        [60.062570, 31.560027],
                        [59.322359, 31.159949],
                        [59.405637, 29.074104],
                    ],
                }).then(function (items) {
                    self.segmentPreloader = false;
                    if (items.length) {
                        items.forEach(function (item) {
                            self.addressesFound.push(item.displayName);
                        });
                    } else {
                        self.isErrorAddressFound = true;
                    }
                });
            },
            // удалить все ранее проложенные пути
            clearRoutes: function () {
                this.routeSegments = [];
                this.yandexMap.geoObjects.removeAll();
            },
            // проложить путь
            createRoute: function () {
                if (!this.inputSearch.length && !Array.isArray(this.selectedAddress.routes)) {
                    return false;
                }
                let self = this;

                this.segmentPreloader = true;
                this.addressesFound = [];
                this.routeSegments = [];
                this.clearRoutes();

                let referencePoints = [],
                    options = {
                        // Автоматически устанавливать границы карты так, чтобы маршрут был виден целиком.
                        boundsAutoApply: true,
                        pinVisible:      false,
                    };
                if (Array.isArray(this.selectedAddress.routes)) {
                    this.selectedAddress.routes.forEach(function(route) {
                        if (route._group === 'text') {
                            referencePoints.push(route.text);
                        } else if (route._group === 'coordinates') {
                            referencePoints.push([
                                parseFloat(route.latitude.replace(',', '.')),
                                parseFloat(route.longitude.replace(',', '.')),
                            ]);
                        }
                    });
                } else {
                    referencePoints.push(self.selectedAddress);
                    referencePoints.push(self.static.address);
                }
                let multiRoute = new ymaps.multiRouter.MultiRoute({
                    referencePoints: referencePoints,
                    params: {
                        routingMode: 'auto',
                    }
                }, options);

                multiRoute.model.events
                    .add("requestsuccess", function (event) {
                        self.addRouteSegments(event);
                    })
                    .add("requestfail", function (event) {
                        console.error(event);
                    });

                this.yandexMap.geoObjects.add(multiRoute);
            },
            // добавить сегменты маршрута (текст, который выдается клиенту)
            addRouteSegments: function (event) {
                let self = this;
                let routes = event.get("target").getRoutes();
                if (this.routeMode === 'masstransit' && this.selectedAddress.stops != null) {
                    this.routeSegments.push('От ТРЦ до ' + this.selectedAddress.text_client.trim());
                    this.routeSegments.push('От ' + this.selectedAddress.text_client.trim() + ' до ТРЦ');
                } else {
                    routes.forEach(function (route) {
                        let segments = route.getPaths()[0].getSegments();

                        segments.forEach(function (segment, index) {
                            let text = segment.properties.get('text')
                                + ', проезжаем ' + segment.properties.get('distance').text
                                + ', ' + segment.properties.get('duration').text;

                            self.routeSegments.push(text);
                        });
                    });
                }

                if (!this.routeSegments.length) {
                    this.isErrorRouteSegment = true;
                }

                this.segmentPreloader = false;
            },
            changeRouteMode: function () {
                this.isErrorRouteSegment = false;
                this.isErrorAddressFound = false;
                this.clearRoutes();
                this.inputSearch = '';
            },
            isAutoRoute: function () {
                return this.routeMode === 'auto';
            },
            clearInputSearch: function () {
                this.inputSearch = '';
                this.clearRoutes();
            },
            setImageModal: function (imagePath) {
                this.imageModal = imagePath
            }
        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// themes/default/assets/src/component/MapHowToGoComponent.vue